(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[647],{

/***/ 85638:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/[article_id]",
      function () {
        return __webpack_require__(26566);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ page; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var page = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    pageId: -1,
    isMobile: 0,
    isTablet: 0,
    isDesktop: 0,
    isPublicDomain: 0,
    appSettings: [],
    destinationId: null,
    propertiesParams: {
        page_id: null,
        limit: 24,
        offset: 0,
        destinations: [],
        tags: [],
        themes: [],
        locations: [],
        statuses: 3
    }
});


/***/ }),

/***/ 26566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Artilce; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55791);
/* harmony import */ var _fancyapps_ui_dist_fancybox_esm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53569);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7108);
/* harmony import */ var _layouts_MainLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66331);






var Articles = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1451), __webpack_require__.e(4366), __webpack_require__.e(2087), __webpack_require__.e(4972), __webpack_require__.e(1964), __webpack_require__.e(4176), __webpack_require__.e(3074), __webpack_require__.e(2411), __webpack_require__.e(2000), __webpack_require__.e(8202), __webpack_require__.e(7540), __webpack_require__.e(7094)]).then(__webpack_require__.bind(__webpack_require__, 87540));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87540)
            ];
        }
    },
    suspense: true
});



var Properties = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4366), __webpack_require__.e(2087), __webpack_require__.e(4972), __webpack_require__.e(1964), __webpack_require__.e(3074), __webpack_require__.e(2411), __webpack_require__.e(1611), __webpack_require__.e(4622)]).then(__webpack_require__.bind(__webpack_require__, 59533));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59533)
            ];
        }
    },
    suspense: true
});
var __N_SSP = true;
function Artilce(props) {
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_5__/* .page */ .M);
    pageContext.pageId = props.app_data.page_id;
    pageContext.isMobile = props.isMobile;
    pageContext.isTablet = props.isTablet;
    pageContext.isDesktop = props.isDesktop;
    pageContext.appSettings = props.app;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), urlHref = ref[0], setUrlHref = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (window !== undefined) {
            setUrlHref(window.location.href + "/");
        }
    }, [
        urlHref
    ]);
    var domain = props.domain;
    var app_data = props.app_data;
    var app = props.app;
    var head = props.head;
    var footer = props.footer;
    var locations = props.locations;
    var navigation = props.navigation;
    var content = props.content;
    var articleContent = props.articleContent;
    var rgbDesignColor = props.rgbDesignColor;
    var rgbSearchbarColor = props.rgbSearchbarColor;
    var isDesktop = props.isDesktop;
    var builder = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].objChildExists */ .Z.objChildExists(app, "builder") ? app.builder : null;
    var image_fb_meta = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidArray */ .Z.isValidArray(head.og_image) ? head.og_image[0].image : null;
    var contactIcons = {
        phoneIcon: app.showPhoneIconOnMenu,
        chatIcon: app.showChatIconOnMenu,
        mailIcon: app.showMailIconOnMenu,
        phoneIconData: app.menuPhoneIconData,
        chatIconData: app.menuChatIconData,
        mailIconData: app.menuMailIconData
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (window !== undefined) {
            window.designMode = app.designMode;
        }
        _fancyapps_ui_dist_fancybox_esm__WEBPACK_IMPORTED_MODULE_4__/* .Fancybox.bind */ .KR.bind("[data-fancybox]", {
            Image: {
                zoom: false
            }
        });
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Articles, {
                    type: "article",
                    domain: domain,
                    app_data: app_data,
                    app: app,
                    head: head,
                    footer: footer,
                    locations: locations,
                    navigation: navigation,
                    content: articleContent,
                    rgbDesignColor: rgbDesignColor,
                    rgbSearchbarColor: rgbSearchbarColor,
                    isDesktop: isDesktop,
                    image_fb_meta: image_fb_meta,
                    contactIcons: contactIcons,
                    urlHref: urlHref,
                    builder: builder,
                    htmlSections: props.html_sections
                }),
                props.hasOwnProperty("showProperties") && props.showProperties ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Properties, {
                    app: app,
                    builder: builder,
                    propertiesIndex: true,
                    propertiesParams: props.propertiesParams,
                    properties_count: props.properties_count,
                    designMode: app.designMode,
                    searchbarRadius: app.searchbarRadius,
                    searchbarShadow: app.searchbarShadow,
                    bookingSearchbarWithBedrooms: app.bookingSearchbarWithBedrooms,
                    googleMapShow: app.viewMap,
                    googleMapApiKey: app.googleMapsApiKey,
                    propertiesFilters: props.propertiesFilters,
                    updateUri: false
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
            ]
        })
    }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5726,2828,8051,3512,7948,571,75,1682,7063,7633,6171,6331,9774,2888,179], function() { return __webpack_exec__(85638); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);